import { type ApiResponse, type RequestFailure } from '@owl-nest/api-client'
import { type PromiseAction } from '@owl-nest/redux-wrapper'
import * as api from '@owl-nest/api-client/latest'
import * as Enum from '@owl-nest/legacy-enum'

import { type RootState } from '../reducers'

export const TYPE = Enum.create({
  LOAD_REQUEST: 'EVENTS.LOAD_REQUEST',
  LOAD_FAILURE: 'EVENTS.LOAD_FAILURE',
  LOAD_SUCCESS: 'EVENTS.LOAD_SUCCESS',

  RESET: 'EVENTS.RESET',
})

type LoadRequest = { type: typeof TYPE.LOAD_REQUEST }
type LoadFailure = { type: typeof TYPE.LOAD_FAILURE; failure: RequestFailure }
type LoadSuccess = { type: typeof TYPE.LOAD_SUCCESS; success: EventsLoadSuccess }
type EventsLoadSuccess = api.Pageable<api.EventList | null> & { cacheId: number; forceClean: boolean }

type LoadConfig = { pagination?: string; forceClean?: boolean; loadDrafts?: boolean }

export function load(
  project: api.Project,
  { pagination = undefined, forceClean = false, loadDrafts = false }: LoadConfig = {},
): PromiseAction<RootState, ApiResponse<EventsLoadSuccess>> {
  return {
    types: [TYPE.LOAD_REQUEST, TYPE.LOAD_SUCCESS, TYPE.LOAD_FAILURE],
    promise: async (_, state) => {
      const getParams = new URLSearchParams(pagination)
      if (state.user.identity.type === 'loggedin' && loadDrafts) {
        getParams.set('with_draft_news', 'true')
      }

      const response = await api.api.get.projectEvents({
        urlParams: { projectId: String(project.id) },
        getParams,
        withToken: state.user.identity.type === 'loggedin',
      })

      return response.next((success) => {
        return { ...success.body, cacheId: project.id, forceClean }
      })
    },
  }
}

type Reset = { type: typeof TYPE.RESET }
export function reset() {
  return { type: TYPE.RESET }
}

export type Action = LoadRequest | LoadFailure | LoadSuccess | Reset
